// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type CopyDashboardModalType from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const AsyncCopyDashboardModal = lazyForPaint(
	() => import(/* webpackChunkName: "async-copy-dashboard-modal" */ './index'),
	{ ssr: false },
);

const AsyncCopyDashboardModalContainer = (
	props: JSX.LibraryManagedAttributes<
		typeof CopyDashboardModalType,
		ComponentProps<typeof CopyDashboardModalType>
	>,
): React.JSX.Element => (
	<Placeholder name="dashboard-modal" fallback={<></>}>
		<AsyncCopyDashboardModal {...props} />
	</Placeholder>
);
export default AsyncCopyDashboardModalContainer;
